module.exports = __webpack_public_path__ + "img/61-80.f310e5c8.svg";